// src/config/env.ts
type NodeEnv = 'development' | 'production' | 'test';
export const ACCESS_TOKEN_KEY = 'braincrea_access_token';

export const env = {
  NODE_ENV: (process.env.NODE_ENV as NodeEnv) || 'development',
  PORT: 3000,
  APP_NAME: 'Braincrea' as const,
  APP_URL: 'https://www.braincrea.com' as const,

  // API_BASE_URL: 'http://localhost:7700/api/v1' as const,
  // IMAGE_BASE_URL: 'http://localhost:7700/storage/' as const,
  // IMAGE_BASE_URL_SANS_STORAGE: 'http://localhost:7700/' as const,


  API_BASE_URL: 'https://api.braincrea.com/api/v1' as const,
  IMAGE_BASE_URL: 'https://api.braincrea.com/storage/' as const,
  IMAGE_BASE_URL_SANS_STORAGE: 'https://api.braincrea.com/' as const,

  // ============================================
  // 🔐 AUTH ROUTES
  // ============================================
  REGISTER_URL: '/auth/register',
  LOGIN_URL: '/auth/login',
  FORGOT_PASSWORD_URL: '/auth/forgot-password',
  LOGOUT_URL: '/logout',
  VERIFY_CODE_URL: '/auth/verify-code',
  RESET_PASSWORD_URL: '/auth/reset-password',
  AUTH_URL: "/auth/login",

  USER_INFOS_URL: '/user/infos',

  // ============================================
  // 👤 USER
  // ============================================
  UPDATE_PROFILE_PHOTO_URL: '/user/update-profile-photo',
  DELETE_PROFILE_PHOTO_URL: '/user/delete-profile-photo',
  UPDATE_PERSONAL_INFO_URL: '/user/update-personal-info',
  UPDATE_PASSWORD_URL: '/user/update-password',

  // ============================================
  // ⚙️ PUBLIC 
  // ============================================
  PUBLIC_SETTINGS_URL: '/public/settings',
  PUBLIC_SERVICES_URL: '/public/services',

  // ============================================
  // 🧩 SERVICES
  // ============================================
  ADMIN_SERVICES_URL: '/admin/services',

  /**
   * ============================================
   * 🛒 PRODUCTS (PUBLIC)
   * ============================================
   */
  PUBLIC_PRODUCTS_URL: '/public/products',
  PUBLIC_PRODUCT_URL: (id: string) => `/public/products/${id}`,

  /**
   * ============================================
   * 🧩 PROJECTS (ADMIN)
   * ============================================
   */
  ADMIN_PROJECTS_URL: '/admin/projects',
  ADMIN_PROJECT_THUMBNAIL_URL: (id: string) => `/admin/projects/${id}/thumbnail`,
  ADMIN_PROJECT_GALLERY_URL: (id: string) => `/admin/projects/${id}/gallery`,
  ADMIN_PROJECT_GALLERY_DELETE_URL: (id: string, index: number) => `/admin/projects/${id}/gallery/${index}`,

  /**
   * 🧩 PRODUCT CATEGORIES (PUBLIC)
   */
  PUBLIC_PRODUCT_CATEGORIES_URL: '/public/product-categories',

  /**
   * ============================================
   * 🧩 PROJECT CATEGORIES (ADMIN)
   * ============================================
   */
  ADMIN_PROJECT_CATEGORIES_URL: '/admin/project-categories',

  /**
   * ============================================
   * 🛍️ PRODUCT CATEGORIES (ADMIN)
   * ============================================
   */
  ADMIN_PRODUCT_CATEGORIES_URL: '/admin/products-categories',

  /**
   * ============================================
   * 🛒 PRODUCTS (ADMIN)
   * ============================================
   */
  ADMIN_PRODUCTS_URL: '/admin/products',
  ADMIN_PRODUCT_THUMBNAIL_URL: (id: string) => `/admin/products/${id}/thumbnail`,
  ADMIN_PRODUCT_GALLERY_URL: (id: string) => `/admin/products/${id}/gallery`,
  ADMIN_PRODUCT_GALLERY_DELETE_URL: (id: string, index: number) => `/admin/products/${id}/gallery/${index}`,

  // Ressources
  ADMIN_PRODUCT_RESOURCES_URL: (id: string) => `/admin/rs/${id}/resources`,
  ADMIN_PRODUCT_RESOURCE_DELETE_URL: (id: string, resourceId: string) => `/admin/rs/${id}/resources/${resourceId}`,

  /**
   * ============================================
   * 🎬 PROJECTS (PUBLIC)
   * ============================================
   */
  PUBLIC_PROJECTS_URL: '/public/projects',
  PUBLIC_PROJECT_URL: (id: string) => `/public/projects/${id}`,
  PUBLIC_PROJECT_CATEGORIES_URL: '/public/project-categories',

  // ============================================
  // ⚙️ ADMIN SETTINGS
  // ============================================
  ADMIN_SETTINGS_URL: '/admin/settings',
  ADMIN_SETTINGS_UPDATE_URL: '/admin/settings/updata',
  ADMIN_SETTINGS_MEDIA_URL: '/admin/settings/media',

  /**
   * ============================================
   * 📩 CONTACT (PUBLIC)
   * ============================================
   */
  PUBLIC_CONTACT_URL: '/public/contact',

  /**
   * ============================================
   * 📋 DEVIS (PUBLIC)
   * ============================================
   */
  PUBLIC_DEVIS_SUBMIT_URL: '/public/devis-requests',
  PUBLIC_DEVIS_TRACK_URL: (ref: string) => `/public/devis-requests/${ref}`,

  /**
   * ============================================
   * 👤 ADMIN USERS
   * ============================================
   */
  USERS: {
    ADMIN: {
      BASE: '/admin/users',
      BAN: (email: string) => `/admin/users/${encodeURIComponent(email)}/ban`,
      UNBAN: (email: string) => `/admin/users/${encodeURIComponent(email)}/unban`,
      ADD_ROLE: (email: string) => `/admin/users/${encodeURIComponent(email)}/roles/add`,
      REMOVE_ROLE: (email: string) => `/admin/users/${encodeURIComponent(email)}/roles/remove`,
    },
  },

  /**
   * ============================================
   * 🎭 ROLES
   * ============================================
   */
  ROLES: {
    ADMIN: '/admin/roles',
  },

  /**
   * ============================================
   * 📋 DEVIS ADMIN
   * ============================================
   */
  ADMIN_DEVIS: {
    BASE: '/admin/devis-requests',
    STATUS: (id: string) => `/admin/devis-requests/${id}/status`,
    MESSAGES: (id: string) => `/admin/devis-requests/${id}/messages`,
    MARK_USER_READ: (id: string) => `/admin/devis-requests/${id}/mark-user-read`,
    DELETE: (id: string) => `/admin/devis-requests/${id}`,
    SHOW: (id: string) => `/admin/devis-requests/${id}`,
  },

  /**
   * ============================================
   * 🛒 ORDERS (USER)
   * ============================================
   */
  ORDERS: {
    CREATE: '/user/orders',
    MY_ORDERS: '/user/orders/my-orders',
    LATEST_ORDER: '/user/orders/latest',
    SHOW: (id: string) => `/user/orders/${id}`,
  },

  /**
   * ============================================
   * 💳 PAYMENTS (USER)
   * ============================================
   */
  PAYMENTS: {
    INITIATE: '/user/order/payment/initiate',
    CHECK_TRANSACTION: (transactionId: string) => `/user/order/payment/check-transaction/${transactionId}`,
  },

  /**
   * ============================================
   * 👨‍💼 ADMIN ORDERS
   * ============================================
   */
  ADMIN_ORDERS: {
    BASE: '/admin/orders',
    SHOW: (id: string) => `/admin/orders/${id}`,
    UPDATE_STATUS: (id: string) => `/admin/orders/${id}/status`,
    DELETE: (id: string) => `/admin/orders/${id}`,
    SEND_WHATSAPP: (id: string) => `/admin/orders/${id}/send-whatsapp`,
  },

  /**
   * ============================================
   * 📊 ADMIN DASHBOARD
   * ============================================
   */
  ADMIN_DASHBOARD: '/admin/dashboard',

  /**
   * ============================================
   * 📈 ADMIN PRODUCT STATS
   * ============================================
   */
  ADMIN_PRODUCT_STATS: {
    OVERVIEW: '/admin/products/stats/overview',
    TOP: '/admin/products/stats/top',
    CATEGORIES: '/admin/products/stats/categories',
  },

  /**
   * ============================================
   * 👥 ADMIN CUSTOMERS
   * ============================================
   */
  ADMIN_CUSTOMERS: {
    BASE: '/admin/customers',
    SHOW: (id: string) => `/admin/customers/${id}`,
  },

  /**
   * ============================================
   * 💳 ADMIN TRANSACTIONS
   * ============================================
   */
  ADMIN_TRANSACTIONS: {
    BASE: '/admin/transactions',
    SHOW: (id: string) => `/admin/transactions/${id}`,
  },

  /**
   * ============================================
   * 📄 ADMIN REPORTS
   * ============================================
   */
  ADMIN_REPORTS: {
    ORDERS: '/admin/reports/orders',
    SALES: '/admin/reports/sales',
    EXPORT_CSV: '/admin/reports/export/csv',
    EXPORT_PDF: '/admin/reports/export/pdf',
  },



  /**
   * ============================================
   * 🛒 USER PURCHASES
   * ============================================
   */
  USER_PURCHASES: {
    DASHBOARD: '/user/purchases/dashboard',
    DIGITAL: '/user/purchases/digital',
    PHYSICAL: '/user/purchases/physical',
    TRANSACTIONS: '/user/purchases/transactions',
    PRODUCT_RESOURCES: (productId: string) => `/user/purchases/product/${productId}/resources`,
    DOWNLOAD_RESOURCE: (productId: string, resourceId: string) =>
      `/user/purchases/product/${productId}/resource/${resourceId}/download`,
  },

  // ============================================
  // BASE
  // ============================================
  DEFAULT_REDIRECT_URL: 'https://www.braincrea.com' as const,
};